/** Staff admin top-level page. Tabs: Вработени (list) | Распоред (schedule) |
 *  Провизии (commissions). Owner/manager only (route-guarded). */
import { type ReactNode, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { PageHeader, Tabs } from '../../components/ui.js';

import { CommissionReport } from './CommissionReport.js';
import { CommissionRulesForm } from './CommissionRulesForm.js';
import { ScheduleTab } from './schedule/ScheduleTab.js';
import { StaffList } from './StaffList.js';

type Tab = 'list' | 'schedule' | 'commissions';

export function StaffPage(): ReactNode {
  const { t } = useTranslation();
  const [tab, setTab] = useState<Tab>('list');

  return (
    <div className="grid gap-5">
      <PageHeader title={t('staff.title')} subtitle={t('staff.list.title')} />
      <Tabs
        value={tab}
        onValueChange={(v) => setTab(v as Tab)}
        items={[
          { value: 'list', label: t('staff.list.title') },
          { value: 'schedule', label: t('staff.schedule.title') },
          { value: 'commissions', label: t('staff.commissions.title') },
        ]}
      />

      {tab === 'list' ? <StaffList /> : null}
      {tab === 'schedule' ? <ScheduleTab /> : null}
      {tab === 'commissions' ? (
        <div className="grid gap-5">
          <CommissionRulesForm />
          <CommissionReport />
        </div>
      ) : null}
    </div>
  );
}
